<template>
	<div class="sidebar text-white">
		<p class="text-center">
			Logged in as <strong>{{ username }}</strong>
		</p>

		<router-link :to="{ name: 'statistics' }" class="sidebar-link" exact>
			<span class="fa fa-fw fa-home mr-2" />
			Home
		</router-link>

		<router-link :to="{ name: 'categories' }" class="sidebar-link">
			<span class="fa fa-fw fa-tags mr-2" />
			Categories
		</router-link>

		<router-link :to="{ name: 'products' }" class="sidebar-link">
			<span class="fa fa-fw fa-boxes mr-2" />
			Products
		</router-link>

		<router-link :to="{ name: 'offers' }" class="sidebar-link">
			<span class="fa fa-fw fa-star mr-2" />
			Offers
		</router-link>

		<router-link :to="{ name: 'coupons' }" class="sidebar-link">
			<span class="fa fa-fw fa-gift mr-2" />
			Coupons
		</router-link>

		<router-link :to="{ name: 'news' }" class="sidebar-link">
			<span class="fa fa-fw fa-newspaper mr-2" />
			News
		</router-link>

		<router-link :to="{ name: 'users' }" class="sidebar-link">
			<span class="fa fa-fw fa-users mr-2" />
			Users
		</router-link>

		<router-link :to="{ name: 'orders' }" class="sidebar-link">
			<span class="fa fa-fw fa-money-check mr-2" />
			Orders
		</router-link>

		<router-link :to="{ name: 'settings' }" class="sidebar-link" >
			<span class="fa fa-fw fa-cogs mr-2" />
			Settings
		</router-link>

		<p class="version mb-0 mt-2">
			Version: 1.0
		</p>
	</div>
</template>


<script>
import { mapState } from 'vuex';

export default {
	computed: {
		...mapState({
			username: state => state.auth.self.username,
		}),
	},
};
</script>
